import React from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { GridToolbarContainer } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";


export default function FileInputButton({ onFileSelect, disabled }) {
    const fileInputRef = React.useRef();

    const { t, i18n } = useTranslation();


    const handleChange = (e) => {
        const file = e.target.files?.[0];
        if (file) onFileSelect(file);
        fileInputRef.current.value = null;
    };

    return (
        <GridToolbarContainer>
            <Button
                color="primary"
                startIcon={<AddIcon />}
                disabled={disabled}

                onClick={(e) => {
                    e.stopPropagation();
                    fileInputRef.current?.click();
                }}

            >
                {t("Upload CSV File")}

            </Button>
            <input
                type="file"
                hidden
                onChange={handleChange}
                ref={fileInputRef}
            />
        </GridToolbarContainer>

    );
}